<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <span class="item-name">
            <i class="fa fa-arrow-left mtv-primary-color clickable m-t-sm m-r-sm"
               (click)="userRoleService.showAmenityPermissionsTable = false;">
            </i>
            {{role.name}} Amenity Settings
        </span>
        <span class="close-detailed-view" (click)="close()">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info">
            <div class="row m-b-sm m-t-md" [hidden]="userRoleService.buildings.length < 2">
                <div class="col-md-3">
                    <label class="m-t-xs">Building</label>
                </div>
                <div class="col-md-9" style="padding: 0 6px;">
                    <search-select ngModel
                                   name="buildingId"
                                   (ngModelChange)="getAmenityPermissions($event)"
                                   [data]="convertToSearchSelectFormat(userRoleService.buildings)">
                    </search-select>
                </div>
            </div>

            <form *ngIf="amenityPermissions.length > 0"
                  #form="ngForm"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  (ngSubmit)="onSubmit(form)">
                <table class="user-role-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="readCheckAll"
                                               type="checkbox"
                                               name="readCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'r')"
                                               [checked]="allInColumnAreChecked('r')">
                                        <label for="readCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Read
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="createCheckAll"
                                               type="checkbox"
                                               name="createCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'c')"
                                               [checked]="allInColumnAreChecked('c')">
                                        <label for="createCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Create
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="updateCheckAll"
                                               type="checkbox"
                                               name="updateCheckAll"
                                               [disabled]="isColumnCheckboxDisabled()"
                                               (change)="checkEntireColumnPermissions($event, 'u')"
                                               [checked]="allInColumnAreChecked('u')">
                                        <label for="updateCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Update
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="deleteCheckAll"
                                               type="checkbox"
                                               name="deleteCheckAll"
                                               [disabled]="isColumnCheckboxDisabled() ||
                                                           !allInColumnAreChecked('u') || !allInColumnAreChecked('c')"
                                               (change)="checkEntireColumnPermissions($event, 'd')"
                                               [checked]="allInColumnAreChecked('d')">
                                        <label for="deleteCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Delete
                                </div>
                            </th>
                            <th>
                                <div class="display-flex">
                                    <label class="img-checkbox">
                                        <input id="approveCheckAll"
                                               type="checkbox"
                                               name="approveCheckAll"
                                               [disabled]="isColumnCheckboxDisabled() ||
                                                           !allInColumnAreChecked('u') || !allInColumnAreChecked('c')"
                                               (change)="checkEntireColumnPermissions($event, 'a')"
                                               [checked]="allInColumnAreChecked('a')">
                                        <label for="approveCheckAll"><svg-checked></svg-checked></label>
                                    </label>
                                    Approve
                                </div>
                            </th>
                            <!--<th>-->
                                <!--<div class="display-flex">-->
                                    <!--<label class="img-checkbox">-->
                                        <!--<input-->
                                            <!--id="settingsCheckAll"-->
                                            <!--type="checkbox"-->
                                            <!--name="settingsCheckAll"-->
                                            <!--[disabled]="isColumnCheckboxDisabled()"-->
                                            <!--(change)="checkEntireColumnPermissions($event, 's')"-->
                                            <!--[checked]="allInColumnAreChecked('s')">-->
                                        <!--<label for="settingsCheckAll"><svg-checked></svg-checked></label>-->
                                    <!--</label>-->
                                    <!--Settings-->
                                <!--</div>-->
                            <!--</th>-->
                        </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of amenityPermissions; let i = index">
                        <td class="display-flex">
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+'CheckAll'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+'CheckAll'}}"
                                       (change)="checkAllPermissions($event, item)"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || isCurrentRole"
                                       [checked]="allPermissionsAreChecked(item)">
                                <label for="{{item.amenity?.id+'CheckAll'}}"><svg-checked></svg-checked></label>
                            </label>
                            <div class="amenity-name" [title]="item.amenity.name">{{ item.amenity.name }}</div>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+':'+'r'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+':'+'r'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   isCurrentRole || item === 'bldn'"
                                       (change)="selectRead($event, item)"
                                       [(ngModel)]="item.rolePermissions.r">
                                <label for="{{item.amenity?.id+':'+'r'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+':'+'c'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+':'+'c'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   isCurrentRole || !item.rolePermissions.r"
                                       (click)="selectUpdate($event, item, 'c')"
                                       [(ngModel)]="item.rolePermissions.c">
                                <label for="{{item.amenity?.id+':'+'c'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+':'+'u'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+':'+'u'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') ||
                                                   isCurrentRole || !item.rolePermissions.r"
                                       (click)="selectUpdate($event, item, 'u')"
                                       [(ngModel)]="item.rolePermissions.u">
                                <label for="{{item.amenity?.id+':'+'u'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+':'+'d'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+':'+'d'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || isCurrentRole ||
                                                   !item.rolePermissions.c || !item.rolePermissions.u"
                                       [(ngModel)]="item.rolePermissions.d">
                                <label for="{{item.amenity?.id+':'+'d'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>
                            <label class="img-checkbox">
                                <input id="{{item.amenity?.id+':'+'a'}}"
                                       type="checkbox"
                                       name="{{item.amenity?.id+':'+'a'}}"
                                       [disabled]="!userRoleService.account.canUpdate('auth') || isCurrentRole ||
                                                   (!item.rolePermissions.c || !item.rolePermissions.u)"
                                       [(ngModel)]="item.rolePermissions.a">
                                <label for="{{item.amenity?.id+':'+'a'}}"><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <!--<td>-->
                            <!--<label class="img-checkbox">-->
                                <!--<input-->
                                    <!--id="{{item.amenity?.id+':'+'s'}}"-->
                                    <!--type="checkbox"-->
                                    <!--name="{{item.amenity?.id+':'+'s'}}"-->
                                    <!--[disabled]="!userRoleService.account.canUpdate('auth') || isCurrentRole ||-->
                                                <!--(!item.rolePermissions.c || !item.rolePermissions.u)"-->
                                    <!--[(ngModel)]="item.rolePermissions.s">-->
                                <!--<label for="{{item.amenity?.id+':'+'s'}}"><svg-checked></svg-checked></label>-->
                            <!--</label>-->
                        <!--</td>-->
                    </tr>
                    </tbody>
                </table>
                <div *ngIf="userRoleService.account.canUpdate('auth') && !isCurrentRole" class="confirmation-box">
                    <p class="col-sm-8 alert-text" *ngIf="checkForChanges()">
                        Please note that permissions have been modified and will affect all users with this user role.
                    </p>
                    <button class="btn btn-primary btn-w-m submit-btn" type="submit" [disabled]="disabledSubmit">
                        Save
                    </button>
                </div>
            </form>
            <h2 *ngIf="amenityPermissions.length < 1 && !showSpinner" class="text-center">
                This building has no amenities
            </h2>
            <spinner [spinnerShow]="showSpinner"></spinner>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/amenity-permissions-view/amenity-permissions-view.component.html